import api from '../../../services/api';
import type { WorkflowInvoice } from '../../../types/workflowInvoice';

export async function fetchInvoiceDatedRate(currency: string, date: string): Promise<NonNullable<WorkflowInvoice['exchangeRateSnapshot']>> {
  const { data } = await api.get('/exchange-rates/quote', { params: { currency, date } });
  if (!Number.isFinite(data?.rate) || data.rate <= 0 || !data.tableNumber || !data.effectiveDate || !['NBP', 'NBP_HISTORICAL'].includes(data.source)
    || data.currency !== currency || data.requestedDate !== date
    || !Number.isFinite(Date.parse(data.effectiveDate)) || data.effectiveDate > date) {
    throw new Error('INVOICE_CURRENT_FX_UNAVAILABLE');
  }
  return data;
}
